import SelectFilterModal from './SelectFilterModal'
import useWojewodztwoFilterModal from '../hooks/useWojewodztwoFilterModal'

export default function WojewodztwoFilterModal({
	isOpen,
	onClose,
	selectedWojewodztwoId,
	onApply,
	title = 'Filtruj po wojewodztwie',
	description = 'Wybierz wojewodztwo, aby zawezic liste placowek.',
	applyLabel = 'Zastosuj',
	clearLabel = 'Wyczysc filtr',
}) {
	const state = useWojewodztwoFilterModal(isOpen, selectedWojewodztwoId)
	return (
		<SelectFilterModal
			isOpen={isOpen}
			onClose={onClose}
			onApply={onApply}
			title={title}
			description={description}
			placeholder="Szukaj wojewodztwa po nazwie..."
			emptyMessage="Nie znaleziono wojewodztw"
			applyLabel={applyLabel}
			clearLabel={clearLabel}
			{...state}
		/>
	)
}
